import { IgnorableNetworkError } from '@/Factories/BookingkitApi/Errors/IgnorableNetworkError';

export class ApiNetworkError extends IgnorableNetworkError {
    static fromApiNetworkError(message: string = 'Network error') {
        return new ApiNetworkError(message);
    }
}

export default { ApiNetworkError };
